// /api/upload.js

import baseURL from './config';
import axios from 'axios';
import jquery from 'jquery';
import qs from 'qs';
const local = require('./local');
axios.defaults.baseURL = baseURL;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest';


// 月流量使用情况

export const getFlowInfo = async function (nationcode, key = '') {
    var user = local.useGetter();
    var postData = {
        author: user.username,
        token: user.token,
        nationcode: user.usercode,
    };
    if (key) {
        postData['key'] = key;
    }
    var validRes = function () {
        return new Promise(function (resolve) {
            axios.post(
            '/?r=v1/user/flow-limit',
            qs.stringify(postData)
            ).then(
            function (res) {
                resolve(res);
            });
            
        });
    };
    var result = await validRes();
    return result;
};


// 获取用户磁盘使用情况

export const getCustomerBouns = async function (spaceVal, nationcode) {
    var user = local.useGetter();
    var postData = {
        author: user.username,
        token: user.token,
        nationcode: user.usercode,
        spaceVal: spaceVal
    };
    var validRes = function () {
        return new Promise(function (resolve) {
            axios.post(
            '/?r=v1/user/get-customer-bouns',
            qs.stringify(postData)
            ).then(
            function (res) {
                resolve(res);
            });
            
        });
    };
    var result = await validRes();
    return result;
};


export const diskSpaceWatcher = async function (nationcode) {
    var user = local.useGetter();
    var postData = {
        author: user.username,
        token: user.token,
        nationcode: user.usercode
    };
    var validRes = function () {
        return new Promise(function (resolve) {
            axios.post(
            '/?r=v1/user/disk-space',
            qs.stringify(postData)
            ).then(
            function (res) {
                resolve(res);
            });
            
        });
    };
    var result = await validRes();
    return result;
};


// 文件下载

export const downloader = async function (key, name, nationcode) {
    
    var user = local.useGetter();
    var postData = {
        author: user.username,
        token: user.token,
        nationcode: user.usercode,
        key: key
    };
    
    var validRes = function () {
        return new Promise(function (resolve) {
            axios.post(
            '/?r=v1/file/file-download',
            qs.stringify(postData)
            ).then(
            function (res) {
                resolve(res);
            });
            
        });
    };
    var result = await validRes();
    return result;
};


// 搜索文件

export const fileFinder = async function (keyword, pager, nationcode) {
    var user = local.useGetter();
    var postData = {
        author: user.username,
        keyword: keyword,
        nationcode: user.usercode,
        token: user.token,
        pager: pager
    };
    var validRes = function () {
        return new Promise(function (resolve, reject) {
            axios.post(
            '/?r=v1/file/file-search',
            qs.stringify(postData)
            ).then((res) => {
                resolve(res);
            }, (err) => {
                reject(err);
            })
        });
    };
    var result = await validRes();
    return result;
};


// 删除文件夹

export const fileDeller = async function (id, nationcode) {
    var user = local.useGetter();
    var postData = {
        author: user.username,
        id: id || [],
        token: user.token,
        nationcode: user.usercode
    };
    var validRes = function () {
        return new Promise(function (resolve) {
            axios.post(
            '/?r=v1/file/file-del',
            qs.stringify(postData),
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                }
            }
            ).then(
            function (res) {
                resolve(res);
            })
        });
    };
    var result = await validRes();
    return result;
};


// 返回上一级

export const prevRootRender = async function (cdir, pager, nationcode) {
    var user = local.useGetter();
    var postData = {
        author: user.username,
        cdir: cdir,
        pager: pager,
        nationcode: user.usercode,
        token: user.token
    };
    var validRes = function () {
        return new Promise(function (resolve, reject) {
            axios.post(
            '/?r=v1/file/fold-prev',
            qs.stringify(postData),
            ).then((res) => {
                resolve(res);
            }, (err) => {
                reject(res);
            })
        });
    }
    var result = await validRes();
    return result;
};


// 前往根目录

export const RootListRender = async function (cdir, pager, nationcode) {
    var user = local.useGetter();
    var postData = {
        author: user.username,
        cdir: cdir,
        pager: pager,
        nationcode: user.usercode,
        token: user.token
        
    };
    var validRes = function () {
        return new Promise(function (resolve, reject) {
            axios.post(
            '/?r=v1/file/fold-root',
            qs.stringify(postData)
            ).then(
            function (res) {
                resolve(res);
            }).catch(
            function (err) {
                reject(err);
            }
            );
        });
    };
    var result = await validRes();
    return result;
};


// 上传文件的预处理接口
export const uploader = async function (seqFile, nationcode, cdir, success, error) {
    var user = local.useGetter();
    var seqIndex = seqFile.index;
    var postData = {
        author: user.username,
        nationcode: user.usercode,
        token: user.token,
        folderId: cdir,
        fileName: seqFile.name,
        fileHash: seqFile.hash,
        fileSize: seqFile.size,
        uid: seqIndex
    };
    var validRes = function () {
        return new Promise(function (resolve, reject) {
            axios(
            {
                method: 'post',
                url: '/?r=v1/file/upload',
                data: qs.stringify(postData)
            }
            ).then(
            function (res) {
                success(res);
                resolve(res);
                
            }
            ).catch(
            function (res) {
                
                error(res);
                reject(res);
            }
            )
        });
        
    };
    var result = await validRes();
    return result;
};


// 任务情况通知服务端

export const uploadCallBack = async function (nationCode, tid, folderId) {
    var user = local.useGetter();
    var postData = {
        taskId: tid,
        author: user.username,
        token: user.token,
        folderId: folderId,
        nationCode: nationCode,
    };
    
    var validRes = function () {
        return new Promise(function (resolve, reject) {
            axios(
            {
                method: 'post',
                url: '/?r=v1/file/upload-call-back',
                data: qs.stringify(postData)
            }
            ).then(
            function (res) {
                resolve(res)
            }
            ).catch(
            function (res) {
                reject(res)
            }
            )
        });
        
    };
    var result = await validRes();
    return result;
};


// 进入文件夹
export const EmptyPageFill = async function (cdir, pager, nationCode) {
    var user = local.useGetter();
    var postData = {
        author: user.username,
        cdir: cdir,
        pager: pager,
        nationCode: nationCode,
        token: user.token
    };
    var validRes = function () {
        return new Promise(function (resolve, reject) {
            axios.post(
            '/?r=v1/file/scan-dir',
            qs.stringify(postData),
            ).then((res) => {
                resolve(res);
            }, (err) => {
                reject(err);
            });
        });
    };
    var result = await validRes();
    return result;
};


// 获取用户文件的接口
export const filePuller = async function (curdir, pager, nationcode, activeType = 0) {
    var user = local.useGetter();
    var postData = {
        author: user.username,
        cdir: curdir,
        pager: pager,
        nationcode: user.usercode,
        token: user.token,
        activeType: activeType
    };
    var validRes = function () {
        return new Promise(function (resolve) {
            axios.post(
            '/?r=v1/file/flist',
            qs.stringify(postData),
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                }
            }
            ).then(
            function (res) {
                resolve(res);
            })
        });
    }
    var result = await validRes();
    return result;
};

// 上传文件夹接口

export const filePusher = async function (folder, nationcode) {
    var user = local.useGetter();
    var postData = {
        folder: folder,
        author: user.username,
        nationcode: user.usercode,
        token: user.token
    };
    var validRes = function () {
        return new Promise(function (resolve) {
            axios.post(
            '/?r=v1/file/add',
            qs.stringify(postData),
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                }
            }
            ).then(
            function (res) {
                resolve(res);
            })
        });
    }
    var result = await validRes();
    return result;
};


// 文件分页

export const chunkData = async function (cdir, pager, nationcode) {
    var user = local.useGetter();
    var postData = {
        author: user.username,
        cdir: cdir,
        pager: pager,
        nationcode: user.usercode,
        token: user.token
    };
    var validRes = function () {
        return new Promise(function (resolve, reject) {
            axios.post(
            '/?r=v1/file/data-chunk',
            qs.stringify(postData),
            ).then((res) => {
                resolve(res);
            }, (err) => {
                reject(err);
            })
        });
    };
    var result = await validRes();
    return result;
};


// 检查用户文件磁盘容量

export const diskCapacity = async function (nationcode, filesize) {
    var user = local.useGetter();
    var postData = {
        author: user.username,
        nationcode: user.usercode,
        token: user.token,
        size: filesize
    };
    var validRes = function () {
        return new Promise(function (resolve) {
            axios.post(
            '/?r=v1/user/disk-free',
            qs.stringify(postData),
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                }
            }
            ).then(
            function (res) {
                resolve(res);
            })
        });
    };
    var result = await validRes();
    return result;
};


// 获取文件夹层级列表

export const getLayerOfFolder = async function (itemid, nationcode, languageid) {
    var user = local.useGetter();
    var postData = {
        author: user.username,
        nationcode: user.usercode,
        token: user.token,
        languageid: languageid | 1,
        itemid: itemid
    };
    var validRes = function () {
        return new Promise(function (resolve) {
            axios.post(
            '/?r=v1/file/layers',
            qs.stringify(postData),
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                }
            }
            ).then(
            function (res) {
                resolve(res);
            })
        });
    };
    var result = await validRes();
    return result;
};


// 文件移动

export const setItemParent = async function (moveAttr, nationcode, languageid) {
    var user = local.useGetter();
    var postData = {
        author: user.username,
        nationcode: user.usercode,
        token: user.token,
        languageid: languageid | 1,
        itemid: moveAttr.itemid,
        itemname: moveAttr.name,
        pid: moveAttr.pid,
        tarid: moveAttr.tarid
    };
    var validRes = function () {
        return new Promise(function (resolve) {
            axios.post(
            '/?r=v1/file/item-move',
            qs.stringify(postData),
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                }
            }
            ).then(
            function (res) {
                resolve(res);
            })
        });
    };
    var result = await validRes();
    return result;
};


export default axios;



//////////////////
// WEBPACK FOOTER
// ./api/upload.js
// module id = zK07
// module chunks = 0